<template>
    <v-container id="apicaller">
      <v-card>
        <v-card-title>Api Calls</v-card-title>
        <v-card-text>
      <v-select
        id="apiSelect"
        v-model="selectedApi"
        :items="apis"
        label="Api Calls"
        @change="updateFields"
      />

      <div v-for="field in fields" :key="field.name">
        <v-text-field
          v-model="formData[field.name]"
          :label="field.label"
          :name="field.name"
        />
      </div>

      <p>
        <code>{{ requestType }} {{ endpoint }}{{ query() }}</code>
      </p>
      <v-btn @click="submitApiCall">
Submit
</v-btn>

      <br><v-progress-linear
        :active="busy"
        indeterminate
      />
      <br>
      <label for="response">Response:</label>
      <br>
      <v-textarea id="response" v-model="response" rows="10" cols="50" readonly />
    </v-card-text>
    </v-card>
    </v-container>
</template>

<script>
  import api from '@/helpers/api.js'
  import { cookies } from '@/util/cookies'
  
  export default {
    name: 'ApiCall',

    data () {
      return {
        apis: [
          {
            text: 'Send Missing Certificates',
            value: '/systemTools/sendCertificates',
            type: 'post',
            fields: [
              {
                name: 'account',
                label: 'Account ID',
                type: 'text',
                visible: true,
              },
              {
                name: 'startdate',
                label: 'Start Date',
                type: 'date',
                visible: true,
              },
              {
                name: 'enddate',
                label: 'End Date',
                type: 'date',
                visible: true,
              },
            ],
          },
          {
            text: 'Send Alerts for expired accounts',
            value: '/systemTools/send-expiry-account-alerts',
            type: 'post',
            fields: [
            ],

          },
          {
            text: 'Send Alerts for expired accounts',
            value: '/systemTools/send-expiry-account-alerts',
            type: 'post',
            fields: [
            ],

          },
          {
            text: 'Send standard accounts expiry notifications',
            value: '/accounts/send-expiry-accounts-alerts',
            type: 'post',
          },
          {
            text: 'Send standard accounts expiry notifications',
            value: '/accounts/send-expiry-accounts-alerts',
            type: 'post',
          },
          {
            text: 'Activate multi factor authenication for an account',
            value: '/accounts/activate-multi-factor-authenication',
            type: 'post',
            fields: [
              {
                name: 'account',
                label: 'Account ID',
                type: 'text',
                visible: true,
              },
            ],
          },
        ],
        selectedApi: '',
        fields: [],
        requestType: '',
        formData: {},
        response: '',
        busy: false,
      }
    },

    computed: {
      endpoint () {
        return cookies.get('baseUrl') ?? process.env.VUE_APP_BODYSWAPS_API_ENDPOINT
      },
    },

    methods: {
      updateFields () {
        for (var i = 0; i < this.apis.length; i++) {
          if (this.apis[i].value === this.selectedApi) {
            this.fields = this.apis[i].fields
            this.requestType = this.apis[i].type
            break
          }
        }
        this.formData = {}
      },

      query () {
        var queryString = ''
        for (var key in this.formData) {
          queryString += key + '=' + encodeURIComponent(this.formData[key]) + '&'
        }
        return this.selectedApi + '?' + queryString
      },

      async submitApiCall () {
        // Build the query string from formData
        const queryString = this.query()
        this.busy = true
        // Make the API call
        try {
          const response = await api.request(this.requestType, queryString)
          this.response = JSON.stringify(response)
          this.busy = false
        } catch (ex) {
          this.response = 'Error: ' + ex.message
          this.busy = false
        }
      },
    },
  }
</script>

<style scoped>
</style>
